import axios from "axios";

const prepareData = (data) => {
  return { project_drawing_office_work_package: data };
};

const BASE = "/project/drawing_office/work_packages";

// Plural Actions
export const GET_ALL_PROJECT_DRAWING_OFFICE_WORK_PACKAGES = "get_all_project_drawing_office_work_packages";
export const getAllProjectDrawingOfficeWorkPackages = (showCompleted = false) => {
  const qs = showCompleted ? "?show_completed=true" : "";
  const request = axios.get(`${BASE}/all_projects.json${qs}`);
  return {
    type: GET_ALL_PROJECT_DRAWING_OFFICE_WORK_PACKAGES,
    payload: request,
  };
};

export const GET_MY_WORKPACKAGES_PROJECT_DRAWING_OFFICE_WORK_PACKAGES = "get_my_workpackages_project_drawing_office_work_packages";
export const getMyWorkpackagesProjectDrawingOfficeWorkPackages = (showCompleted = false) => {
  const qs = showCompleted ? "?show_completed=true" : "";
  const request = axios.get(`${BASE}/my_workpackages.json${qs}`);
  return {
    type: GET_MY_WORKPACKAGES_PROJECT_DRAWING_OFFICE_WORK_PACKAGES,
    payload: request,
  };
};

export const GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGES = "get_project_drawing_office_work_packages";
export const getProjectDrawingOfficeWorkPackages = (showCompleted = false) => {
  const qs = showCompleted ? "?show_completed=true" : "";
  const request = axios.get(`${BASE}.json${qs}`);
  return {
    type: GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGES,
    payload: request,
  };
};

// Singular Actions
export const CREATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE = "create_project_drawing_office_work_package";
export const createProjectDrawingOfficeWorkPackage = (data) => {
  const request = axios({ method: "post", url: `${BASE}.json`, data: prepareData(data) });
  return {
    type: CREATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
    payload: request,
  };
};

export const GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGE = "get_project_drawing_office_work_package";
export const getProjectDrawingOfficeWorkPackage = (id) => {
  const request = axios.get(`${BASE}/${id}.json`);
  return {
    type: GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
    payload: request,
  };
};

export const UPDATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE = "update_project_drawing_office_work_package";
export const updateProjectDrawingOfficeWorkPackage = (id, data) => {
  const request = axios({ method: "patch", url: `${BASE}/${id}.json`, data: prepareData(data) });
  return {
    type: UPDATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
    payload: request,
  };
};

export const DESTROY_PROJECT_DRAWING_OFFICE_WORK_PACKAGE = "destroy_project_drawing_office_work_package";
export const destroyProjectDrawingOfficeWorkPackage = (id) => {
  const request = axios({ method: "delete", url: `${BASE}/${id}.json` });
  return {
    type: DESTROY_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
    payload: request,
  };
};
